import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsViewHeader from '../components/leads/ModuleTableCreateHeader'
import LeadsViewContent from '../components/leads/ModuleTableCreate'
import LeadsViewTab from '../components/leadsViewCreate/LeadsViewTab'
import Footer from '../components/shared/Footer'

const ModuleTableCreate = () => {
    return (
        <>
            <PageHeader>
                <LeadsViewHeader />
            </PageHeader>
            <LeadsViewTab />
            <div className='main-content'>
                <div className='tab-content'>
                    {/* <LeadssTable /> */}
                    <LeadsViewContent />
                </div>
            </div>
            
        </>
    )
}

export default ModuleTableCreate